import React from "react";

const PublicFiltersBar = ({
  search,
  setSearch,
  selectedClub,
  setSelectedClub,
  clubs,
  tab,
  setTab,

  // ✅ nouveaux
  selectedAge,
  setSelectedAge,
  selectedPoids,
  setSelectedPoids,
  selectedGender,
  setSelectedGender,
  ageOptions = [],
  poidsOptions = [],
}) => {
  const inputCls =
    "border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition";

  const tabBtn = (key, label) => (
    <button
      key={key}
      onClick={() => setTab(key)}
      className={`px-3 py-2 rounded-lg text-sm font-semibold ${
        tab === key
          ? "bg-blue-600 text-white"
          : "bg-white/70 dark:bg-slate-800/60 text-gray-800 dark:text-white border border-gray-200/70 dark:border-slate-700/70"
      }`}
    >
      {label}
    </button>
  );

  return (
    <div className="mx-auto max-w-[1280px] w-full">
      <div className="rounded-2xl bg-white/70 dark:bg-slate-900/60 backdrop-blur p-3 border border-gray-200/70 dark:border-slate-700/70 shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-2">
          <input
            type="text"
            placeholder="Rechercher un club ou un judoka…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className={inputCls}
          />

          <select
            value={selectedClub}
            onChange={(e) => setSelectedClub(e.target.value)}
            className={inputCls}
          >
            <option value="">Tous les clubs</option>
            {clubs.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>

          <select
            value={selectedAge}
            onChange={(e) => setSelectedAge(e.target.value)}
            className={inputCls}
          >
            <option value="">Toutes catégories d’âge</option>
            {ageOptions.map((a) => (
              <option key={a} value={a}>
                {a}
              </option>
            ))}
          </select>

          <select
            value={selectedPoids}
            onChange={(e) => setSelectedPoids(e.target.value)}
            className={inputCls}
          >
            <option value="">Toutes catégories de poids</option>
            {poidsOptions.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>

          <select
            value={selectedGender}
            onChange={(e) => setSelectedGender(e.target.value)}
            className={inputCls}
          >
            <option value="">Tous genres</option>
            <option value="M">Masculin</option>
            <option value="F">Féminin</option>
          </select>

          <div className="flex items-center gap-2 flex-wrap">
            {tabBtn("results", "Résultats")}
            {tabBtn("ongoing", "En cours")}
            {tabBtn("podiums", "Podiums")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicFiltersBar;
